// Some apps (looking at you, Microsoft) copy both HTML and an image
// representation of that HTML. In most cases, if we get both HTML and
// an image, we should favor the image. But in those cases, we want to
// favor the HTML instead.
export default function preferHTMLContent(transfer: DataTransfer): boolean {
  const html = transfer.getData('text/html');
  if (!html) return false;

  // Check for metadata indicating this is HTML copied from OneNote.
  if (html.match(/OneNote\.File/)) return true;

  // Check for a class that Excel puts in its table HTML.
  // Latest versions of Excel on Mac don't seem to include ", make it optional
  if (html.match(/class="?xl/)) return true;

  return false;
}
